import {
  useNavigate as useDefaultNavigate,
  useLocation,
  To,
  NavigateOptions,
} from "react-router-dom";

type CustomNavigateOptions = NavigateOptions & {
  keepState?: boolean;
};

type NavigateWithKeepState = (to: To, options?: CustomNavigateOptions) => void;

export const useNavigate = (): NavigateWithKeepState => {
  const defaultNavigate = useDefaultNavigate();
  const location = useLocation();

  const navigate: NavigateWithKeepState = (to, options = {}) => {
    const { keepState, ...rest } = options;

    const finalOptions: NavigateOptions = {
      ...rest,
      state: keepState ? location.state : options.state,
    };

    defaultNavigate(to, finalOptions);
    window.scrollTo(0, 0);
  };

  return navigate;
};